import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true
  },
  actionTypes: {
    score: ['FIELD_GOAL', 'SAFETY', 'GOAL', 'YES', 'TOUCHDOWN']
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.info.number,
          away: ingameData => ingameData.info.yards,
          divider: '-'
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'match-center'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    info: {
      number: 0,
      yards: 0
    },
    score: {
      home: 0,
      away: 0
    },
    coords: {
      x: 35,
      y: 0
    },
    leftSideTeam: 1,
    getOvertimePeriodName: 'OT'
  }
}
